export default "__VITE_ASSET__CTJlgsHM__"